import { AudioContentItem } from '../content/AudioContentItem'
import { CarouselContentItem } from '../content/CarouselContentItem'
import { CastContentItem } from '../content/CastContentItem'
import { InfoSection } from '../content/InfoSection'
import { TextContentItem } from '../content/TextContentItem'
import { TranscodedMedia } from '../content/TranscodedMedia'
import { TriggerContentItem } from '../content/TriggerContentItem'
import { TileCategory } from '../enums/TileCategory'
import { TileTitles } from '../enums/TileTitles'
import { TileType } from '../enums/TileType'

export enum TileColourName {
  DEFAULT = 'default',
  GREEN = 'green',
  VIOLET = 'violet',
  BLUE = 'blue',
  YELLOW = 'yellow',
  RED = 'red',
}
export interface TileItem {
  uid: string
  enabled: boolean
  content?:
    | InfoSection[]
    | TriggerContentItem
    | CastContentItem[]
    | CarouselContentItem[]
    | AudioContentItem
    | TextContentItem
  preview?: string
  media?: TranscodedMedia | null
  badge?: string
  icon_code: string
  category: TileCategory
  tile_type: TileType
  colour_code: TileColourName
  description?: string
  title: TileTitles
  local_axis: number
  group_axis: number
  y_axis: number
}
